<script lang="ts">
    import type { HTMLAttributes } from "svelte/elements";
    import type * as t from "~/types";

    import { EventEmitter } from "~/event-emitter";
    import { getAppContext } from "~/quiz-store";
    import { cn } from "~/utils";

    interface $$Props extends HTMLAttributes<HTMLElement> {}

    const ctx = getAppContext();
    const { state } = ctx;

    function handleScroll(e: UIEvent & { currentTarget: HTMLElement }) {
        const { scrollLeft, scrollTop } = e.currentTarget;
        ctx.events.emit<t.AppEvent.OnContentScroll>(
            EventEmitter.EVENT.ON_CONTENT_SCROLL,
            {
                x: scrollLeft,
                y: scrollTop,
                target: e.currentTarget,
            },
        );
    }

    $: $state.step &&
        ctx.hooks.onBeforeProceed($state.step, () => {
            if (container?.scroll != null) {
                container.scroll({ top: 0, behavior: "instant" });
            }
        });

    let container: HTMLElement;
</script>

<div
    class={cn($$restProps.class, "size-full overflow-y-scroll")}
    on:scroll={handleScroll}
    bind:this={container}
    {...$$restProps}
>
    <slot />
</div>
